import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  selector: 'email-account-recovery-request-started-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './account-recovery-request-started.component.html',
  imports: [
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailMarginComponent,
    EmailLinkComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class AccountRecoveryRequestStartedTemplateComponent {
  @Input({ required: true })
  public data: WrappedValue<AccountRecoveryRequestStartedTemplateData>;
}

export type AccountRecoveryRequestStartedTemplateData = {
  title: string;
  p1: string;
  p2: string;
  p3: string;
  stop_label: string;
  stop_url: string;
  p4: string;
  p5_html: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
};

export const AccountRecoveryRequestStartedTemplateMocks: AccountRecoveryRequestStartedTemplateData[] =
  [
    {
      title: 'Account recovery',
      p1: 'We have received a request to recover access to your account.',
      p2: 'Request time: %{date}',
      p3: 'IP Address: %{ip_address}',
      stop_label: 'Stop recovery now',
      stop_url: 'http://recruitee.com',
      p4: 'Please note that this process can take from 48 to 72 hours.',
      p5_html:
        "If this wasn't you, click the button below to <b>stop the recovery process</b> or <a href='%{url}'>contact our support</a>.",
      footer: {
        text: 'Need help?',
        label: 'Contact us',
        href: 'https://auth.recruitee.com/?intercom_open=true',
        target: '_blank',
      },
    },
  ];
